import React, { MouseEvent } from 'react';
import { Popover } from '@mui/material';
import ExplanationBox from './ExplanationBox';

export default function PopoverTooltip(props: { popoverId: string, children: React.ReactNode, text: string | React.ReactNode, disabled?: boolean }) {
  const {
    children, popoverId, text, disabled,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);
  function handlePopoverOpen(event: MouseEvent<Element>) {
    setAnchorEl(event.currentTarget);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl && !disabled);

  return (
    <>
      <span
        aria-owns={open ? popoverId : undefined}
        aria-haspopup="true"
        onMouseEnter={(event: MouseEvent<Element>) => {
          handlePopoverOpen(event);
        }}
        onMouseLeave={handlePopoverClose}
      >
        {text}
      </span>
      <Popover
        id={popoverId}
        style={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={anchorEl ? { vertical: -12, horizontal: 'center' } : undefined}
        transformOrigin={anchorEl ? { vertical: 'bottom', horizontal: 'center' } : undefined}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <ExplanationBox>
          {children}
        </ExplanationBox>
      </Popover>
    </>
  );
}
